import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTradingViewCandles: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTradingViewCandles"><Path d="M7 2.5V10.5M7 10.5H3.5V18.5H7M7 10.5H10.5V18.5H7M7 18.5V21.5M17 2.5V5.5M17 5.5H13.5V18.5H17M17 5.5H20.5V18.5H17M17 18.5V21.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconTradingViewCandles;
